document.addEventListener('DOMContentLoaded', () => {
  requestAnimationFrame(() => {
    // allowing DOM to settle since events are unstable.
    setTimeout(bindFilterUI, 100);
  });
});

function bindFilterUI() {
  const toggleButton = document.querySelector('.filters-toggle-bar');
  const closeButton = document.querySelector('.filters-close');
  const filtersPanel = document.querySelector('.filters-panel');
  const form = document.getElementById('filter-form');
  const blogBaseUrl = document.getElementById('blog-data')?.dataset.blogUrl || '';
  const isMobile = window.innerWidth < 1024;

  // Toggle panel open/close (mobile/tablet only)
  if (toggleButton && closeButton && filtersPanel) {
    toggleButton.addEventListener('click', () => {
      filtersPanel.classList.add('visible');
      closeButton.classList.add('visible');
    });

    closeButton.addEventListener('click', (e) => {
      e.stopPropagation();
      filtersPanel.classList.remove('visible');
      closeButton.classList.remove('visible');
    });
  }

  if (!form) return;

  if (isMobile) {
    // Mobile/tablet: apply on button click
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const selected = Array.from(form.querySelectorAll('input[type="checkbox"]:checked')).map((cb) =>
        cb.value.trim().toLowerCase().replace(/\s+/g, '-')
      );

      const tagPath = selected.join('+');
      window.location.href = selected.length > 0 ? `${blogBaseUrl}/tagged/${tagPath}` : blogBaseUrl;
    });
  } else {
    // Desktop: apply on change
    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((cb) => {
      cb.addEventListener('change', () => {
        const selected = Array.from(form.querySelectorAll('input[type="checkbox"]:checked')).map((cb) =>
          cb.value.trim().toLowerCase().replace(/\s+/g, '-')
        );

        const tagPath = selected.join('+');
        window.location.href = selected.length > 0 ? `${blogBaseUrl}/tagged/${tagPath}` : blogBaseUrl;
      });
    });
  }

  const clearButton = document.getElementById('clear-filters-button');

  if (clearButton && form) {
    clearButton.addEventListener('click', () => {
      const checkboxes = form.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach((cb) => (cb.checked = false));
    });
  }
}
